module.exports = __webpack_public_path__ + "static/media/1682489560477-invicara_owler_20160227_200730_original.19e8bfe6.png";